"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.setLanguage = exports.getLanguage = exports.getLanguageId = exports.getLocale = exports.setLocale = exports.isDefined = exports.getPermissions = exports.getProfile = exports.remove = void 0;
const Store = __importStar(require("./store"));
const Language = __importStar(require("./language"));
const profileKey = 'profile';
const permissionsKey = 'permissions';
const localeKey = 'locale';
exports.remove = () => {
    Store.remove(profileKey);
    Store.remove(permissionsKey);
    Store.remove(localeKey);
};
exports.getProfile = () => Store.get(profileKey);
exports.getPermissions = () => Store.get(permissionsKey);
exports.isDefined = () => !!exports.getProfile();
exports.setLocale = (lang) => Store.set(localeKey, lang);
exports.getLocale = () => Store.get(localeKey);
exports.getLanguageId = () => {
    try {
        const lg = exports.getLocale();
        return lg.id;
    }
    catch (err) {
        console.log('language not set, using default value');
        return Language.languageIdDefault;
    }
};
exports.getLanguage = () => {
    try {
        const lg = exports.getLocale();
        return lg.name;
    }
    catch (err) {
        throw Error('language not set');
    }
};
exports.setLanguage = (lang) => {
    const locale = Language.langToLocale(lang);
    return exports.setLocale(locale);
};
exports.set = (profile, permissions, lang) => {
    Store.set(profileKey, profile);
    Store.set(permissionsKey, permissions);
    exports.setLanguage(lang);
};
